export const ENDPOINT =
  process.env.NODE_ENV == "development" ? "https://karte.tulip-k.local/" : "/";

export const logd =
  process.env.NODE_ENV == "development"
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (message: () => any) => console.log(message())
    : // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
      (message: () => any) => {};
